<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'sm'">
    <fudis-heading [level]="2" [variant]="'lg'" [class]="'fudis-mb-sm'">
      {{ t("STUDENT_CUSTOM_STUDY_DRAFT_MODAL.TITLE") }} {{ studyDraft.name }}
    </fudis-heading>
    <fudis-dialog-content [contentFocus]="true">
      <fudis-body-text size="xs">{{ t("STUDENT_CUSTOM_STUDY_DRAFT_MODAL.VIEW_MODE_GUIDANCE") }}</fudis-body-text>
      <fudis-dl [classes]="'fudis-mt-md'">
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_CUSTOM_STUDY_DRAFT_MODAL.NAME')" />
          <fudis-dd [contentText]="studyDraft.name" />
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt class="label" [contentText]="t('STUDENT_CUSTOM_STUDY_DRAFT_MODAL.CREDITS')" />
          <fudis-dd class="value" [contentText]="studyDraft.credits | decimalNumber" />
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt class="label" [contentText]="t('STUDENT_CUSTOM_STUDY_DRAFT_MODAL.LOCATION')" />
          <fudis-dd class="value" [contentText]="studyDraft.location" />
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt class="label" [contentText]="t('STUDENT_CUSTOM_STUDY_DRAFT_MODAL.DESCRIPTION')" />
          <fudis-dd class="value" [contentText]="studyDraft.description" />
        </fudis-dl-item>
      </fudis-dl>
    </fudis-dialog-content>
    @if (isSuggestButtonVisible) {
      <fudis-dialog-actions>
        <fudis-button fudisDialogClose [label]="t('BUTTON.CANCEL')" variant="secondary"></fudis-button>
        <fudis-button
          (handleClick)="suggestAttainment.emit()"
          [label]="t('STUDENT_CUSTOM_STUDY_DRAFT_MODAL.SUGGEST_ATTAINMENT')"></fudis-button>
      </fudis-dialog-actions>
    } @else {
      <fudis-dialog-actions>
        <fudis-button fudisDialogClose [label]="t('BUTTON.CLOSE')" variant="secondary"></fudis-button>
      </fudis-dialog-actions>
    }
  </fudis-dialog>
</ng-container>
